// Returns a <wa-toast> stack, creating it on first use. Stacks are keyed by id so
// flash messages and the notifications panel can use independently placed stacks.
// Each <wa-toast> is protected from Turbo morphs in modules/webawesome.
export function toastStack(id = 'flash', placement) {
  let stack = document.querySelector(`wa-toast[data-stack="${id}"]`)

  if (!stack) {
    stack = document.createElement('wa-toast')
    stack.dataset.stack = id
    if (placement) stack.setAttribute('placement', placement)
    document.body.append(stack)
  }

  return stack
}
